module.exports = __webpack_public_path__ + "img/HomeMAC1680.c02b7476.png";